module.exports = __webpack_public_path__ + "img/net-recomment.6bff3e59.svg";